import { createContext } from 'react'
const TranslationContext = createContext({ locale: '' })
export default TranslationContext



// WEBPACK FOOTER //
// ./src/client/utils/TranslationContext.js